import React, { useEffect } from 'react';
import Fireworks from '../assets/fireworks.mp4';
import Navbar from '../pages/Register/Navbar';
import Footer from '../pages/Register/Footer';
import TagManager from 'react-gtm-module';
import { useTranslation } from 'react-i18next';
import { useRTL } from '../hooks/useRTL';

const gtmId = 'GTM-T4QRDGLB';
const initializeTagManager = () => {
  TagManager.initialize({ gtmId });
};

const Thanks = () => {
  const { t, i18n } = useTranslation();
  const isRTL = useRTL();
  useEffect(() => {
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
  }, [isRTL]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const x = params.get('lang');
    if (x === 'ar') {
      i18n.changeLanguage('ar');
      document.documentElement.dir = 'rtl';
    } else {
      i18n.changeLanguage('en');
      document.documentElement.dir = 'ltr';
    }
  }, [i18n]);

  useEffect(() => {
    initializeTagManager();
  }, []);

  return (
    <div
      className={`${isRTL ? 'rtl' : 'ltr'} flex min-h-screen flex-col`}
      dir={isRTL ? 'rtl' : 'ltr'}>
      {/* <div className='navbar'>
        <div className='nav-logo-div'>
          <img alt='TheBooker Logo' src={Logo} />
          <p>TheBooker</p>
        </div>
      </div> */}
      <Navbar isRegisterPage={true} Translated={true} />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <div
          style={{
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
          <video
            playsInline
            autoPlay
            muted
            loop
            style={{ objectFit: 'contain', width: 400 }}>
            <source src={Fireworks} type='video/mp4'></source>
          </video>
          <h1
            style={{
              fontFamily: 'Hurme-Bold',
              color: '#008a80',
              padding: '0 10px',
            }}>
            {t('thanks.IntroKey')}
          </h1>
          <p
            style={{
              fontFamily: 'Hurme-Light',
              marginTop: 10,
              padding: '0 10px',
            }}>
            {t('thanks.SendUpdates')}
          </p>
          <div
            onClick={() => window.location.replace('/')}
            className='subscribe-btn'
            style={{ marginTop: 25 }}>
            {t('thanks.BackToWebsite')}
          </div>
        </div>
      </div>

      {/* <div className='footer-thanks-main'>
        <div
          className='footer-thanks'
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <a
              href='https://www.instagram.com/thebookerapp?igsh=OWEwYXg5YjQ0NXQx'
              target='_blank'
              rel='noreferrer'
              style={{ marginRight: '15px' }}>
              <Instagram width={30} height={30} />
            </a>
            <a
              href='https://www.facebook.com/profile.php?id=61555465270361&mibextid=ZbWKwL'
              target='_blank'
              rel='noreferrer'
              style={{ marginRight: '15px' }}>
              <Facebook width={30} height={30} />
            </a>
            <a
              href='https://www.tiktok.com/@thebooker.app?_t=8laJs404Hl2&_r=1'
              target='_blank'
              rel='noreferrer'
              style={{ marginRight: '15px' }}>
              <Tiktok width={30} height={30} />
            </a>
          </div>
          <p>TheBooker App. All Rights Reserved.</p>
        </div>
      </div> */}

      <div className='mt-20'>
        <Footer ThanksPage={true} />
      </div>
    </div>
  );
};

export default Thanks;
